












import {Component, Vue} from 'vue-property-decorator';
import {
  Action,
} from 'vuex-class';
import Toolbar from '@/modules/common/ui/_components/Toolbar.vue';
import AdminNavigation from '@/components/Admin/AdminNavigation.vue';

@Component({
  components: {
    AdminNavigation,
    Toolbar,
  },
})
export default class UserLayout extends Vue {
  @Action('guest/auth/signOut') private storeSignOut!: () => Promise<void>;
  @Action('guest/auth/loadUser') private loadUser!: any;
  @Action('common/ui/setSidebar') private setSidebar!: any;

  private signOut(): void {
    this.storeSignOut().then(() => {
      this.$router.push({name: 'GuestHome'});
    });
  }

  private mounted() {
    this.setSidebar(true);
  }

  private created() {
    this.loadUser();
  }
}
